// App
import React from 'react';

// Misc / utils
import * as S from './styles';

type CalendarProps = {
  customRef: React.RefObject<HTMLDivElement>;
  handleOnDayClick: (day: Date) => void;
  today: Date;
  from: Date;
  to: Date;
  handleEsc: (e: React.KeyboardEvent) => void;
};

const Calendar = ({ customRef, handleOnDayClick, today, from, to, handleEsc }: CalendarProps) => {
  const modifiers = {
    disabled: function disabled(d1: Date): boolean | undefined {
      const d2 = today;

      if (d1.getFullYear() < d2.getFullYear()) {
        return true;
      }
    },
    selected: function selected(d1: Date): boolean {
      const d2 = today;

      return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
    },
    end: to,
  };

  return (
    <S.StyledDayPicker
      showOutsideDays
      numberOfMonths={1}
      selectedDays={[from, { from, to }]}
      modifiers={modifiers}
      onDayClick={handleOnDayClick}
      onKeyDown={handleEsc}
      disabledDays={{ before: today }}
      labels={{
        nextMonth: 'Next Month',
        previousMonth: 'Previous Month',
      }}
      ref={customRef}
    />
  );
};

export default Calendar;
